<template>
  <!-- Drawer Overlay -->
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-eerie-black bg-opacity-50 z-50"
    @click="closeDrawer"
  >
    <!-- Drawer Content -->
    <div
      class="fixed top-0 flex overflow-auto flex-col right-0 w-80 h-[100dvh] max-h-[100dvh] bg-eerie-black text-total-white shadow-lg border-l-2 border-total-white-100"
      @click.stop
    >
      <!-- Close Button -->
      <button class="absolute top-5 left-5" @click="closeDrawer">
        <i class="fas fa-times text-xl"></i>
      </button>

      <!-- User Info -->
      <div class="pt-12 flex flex-col items-center">
        <div
          class="w-20 h-20 rounded-full flex items-center mb-4 justify-center bg-light-grey-translucent-dark border border-light-grey-translucent-dark overflow-hidden"
        >
          <template v-if="userPicture">
            <img
              :src="userPicture"
              alt="Profile Image"
              class="w-full h-full rounded-full border"
            />
          </template>
          <template v-else>
            <!-- Placeholder icon -->
            <i class="fa-solid fa-user text-6xl text-pitch-black -mb-[1px] mt-auto"></i>
          </template>
        </div>
        <h2 class="text-2xl font-semibold mb-1">{{ first_name }} {{ last_name }}</h2>
        <p class="text-sm text-gray-400">{{ email }}</p>
      </div>

      <!-- Navigation Links -->
      <nav class="mt-8 w-full">
        <ul class="text-lg flex flex-col w-full">
          <a
            href="/projects"
            class="text-prime-golden border-y border-total-white-300 p-2 py-3 w-full"
            >Projects</a
          >
          <a href="/contacts" class="text-prime-golden p-2 py-3 w-full">All Contacts</a>

          <router-link
            :to="{
              path: '/my-account',
              query: { tab: currentTab, projectId: projectId },
            }"
            class="text-prime-golden p-2 py-3 w-full border-y border-total-white-300"
          >
            Account
          </router-link>

          <router-link
            v-if="role === 'admin' && isSimulation"
            :to="{
              name: 'ProjectAlarmsPage',
              params: { id: projectId },
              query: { projectName },
            }"
            class="text-ash-grey p-2 py-3 w-full"
          >
            Alarms
          </router-link>

          <a
            @click="openResetModal"
            v-if="role == 'admin'"
            class="text-ash-grey p-2 py-3 w-full border-y border-total-white-300 hover:cursor-pointer"
          >
            Reset Project
          </a>

          <a
            href="/instructions"
            class="text-ash-grey p-2 py-3 w-full border-b border-total-white-300"
            >Instructions</a
          >

          <a
            href="/agents"
            class="text-ash-grey p-2 py-3 w-full border-b border-total-white-300"
            >Agents</a
          >

          <a
            href="/activations"
            class="text-ash-grey p-2 py-3 w-full border-b border-total-white-300"
            >Activations</a
          >
        </ul>
      </nav>

      <!-- Delete Button (Only for Admin) -->
      <button
        v-if="role == 'admin'"
        @click="openDeleteModal"
        class="text-rusty-orange text-lg p-2 py-3 w-full border-b border-total-white-300"
      >
        Delete Project
      </button>

      <!-- Logout Button -->
      <div class="flex-1 mt-8 text-center flex justify-center items-end mb-4">
        <button
          @click="logout"
          class="px-4 py-2 text-rusty-orange font-semibold rounded-lg"
        >
          Logout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    isSimulation: {
      type: Boolean,
      required: true,
    },
    userPicture: {
      type: String,
      required: false,
    },
    currentTab: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    first_name: {
      type: String,
      required: true,
    },
    last_name: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    projectId: {
      type: Number,
      required: true,
    },
    projectName: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeDrawer() {
      this.$emit("close");
    },
    openDeleteModal() {
      console.log("Open Delete Modal");
      this.$emit("openDeleteModal");
    },
    openResetModal() {
      this.$emit("openResetModal");
    },
    logout() {
      console.log("Logout Pressed");
      this.$emit("logout");
    },
  },
};
</script>

<style scoped>
/* Drawer specific styling */
</style>
